<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 8 8">
  <path d="M1 1L7 7M7 1L1 7" [attr.stroke]="color" stroke-width="2"/>
</svg>